module.exports = __webpack_public_path__ + "img/icon18.93b784ad.png";